import React from 'react';
import i18next from 'i18next';
import classNames from 'classnames';
import Truncate from 'react-truncate';

import { CoreLink } from '@uncinc/react-drupal-core';
import { Image, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import { dateFormatter, getPathFromAlternativePaths } from '../../../../helpers';

import './style.scss';

const InterviewTeaser = ({ entity, className }) => {
  const classes = classNames(className, 'InterviewTeaser');

  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'value'], null);
  const author = entity.getIn(['field_author', 0, 'value']);
  const authorImage = entity.getIn(['field_author_image', 0, 'styles', 'thumbnail']);
  const authorPosition = entity.getIn(['field_author_job_title', 0, 'value'], '');
  const url = getPathFromAlternativePaths(entity, ['interview', 'interview']);

  return (
    <article typeof="schema:WebPage" className={classes}>
      <CoreLink to={url} className="overlapping-link" />
      <div className="InterviewTeaser__content">
        <div>
          <div className="InterviewTeaser__theme">
            {entity.getIn(['field_theme', 0, 'entity', 'name', 0, 'value']) ? (
              <div className="theme-labels">
                <div className="theme-label">
                  {entity.getIn(['field_theme', 0, 'entity', 'name', 0, 'value'], '')}
                </div>
                {entity.getIn(['field_theme']).size > 1 && (
                  <div className="theme-label">
                    +{entity.getIn(['field_theme']).size - 1}
                  </div>
                )}
              </div>
            ) : null}
            <span>{i18next.t('interview')}</span>
          </div>
          <div className="InterviewTeaser__title">
            <h3>{title}</h3>
          </div>
          {body && (
            <div className="InterviewTeaser__body">
              <Truncate lines={3}>
                <WysiwygField
                  property="schema:text"
                  html={entity.getIn(['body', 0, 'processed'], '')}
                />
              </Truncate>
            </div>
          )}
          <div className="InterviewTeaser__date">
            {dateFormatter(entity.getIn(['created', 0, 'value'], new Date()))}
          </div>
        </div>
        <div className="InterviewTeaser__author">
          <div className="InterviewTeaser__author__image">
            <Image
              alt={author}
              lazyload={false}
              src={authorImage} />
          </div>
          <div className="InterviewTeaser__author__details">
            <div className="InterviewTeaser__author__details__name">
              {author}
            </div>
            {authorPosition && (
              <div>
                <Truncate lines={2}>
                  {authorPosition}
                </Truncate>
              </div>
            )}
          </div>
        </div>
      </div>
    </article>
  );
};

export default InterviewTeaser;
